import { isElementInViewport } from 'helpers/dom-helper'
import Backbone from 'init/backbone'

/**
 * Функциональность реакции на попадание в поле зрения пользователя.
 */
export const ItemInViewPortMixin = {

  isInfinityListener: false,

  afterRun: function () {
    // реагируем на скроллинг
    this.listenTo(this.mainWindow, 'window.scroll', this.showListening)
    setTimeout(() => {
      this.showListening()
    }, 250)
  },

  /**
   * Элемент отслеживает свою видимость для пользователя.
   * Элемент считается видимым пользователю если он не скрыт
   * и входит в область просмотра браузера (viewport).
   *
   * После того как элемент был просмотрен пользователем
   * отслеживать его видимость больше не требуется.
   */
  showListening: function () {
    if (this.$el.length) {
      const itemInViewport = isElementInViewport(this.$el, 0)
      if (itemInViewport && this.$el.is(':visible')) {
        if (this.model && this.model instanceof Backbone.Model) {
          this.model.set({ is_viewed: true })
        }
        if (!this.isInfinityListener) {
          // если пользователь нас уже увидел нет нужды больше следить за просмотром
          this.stopListening(this.mainWindow)
        }
      }
    }
  },
}
